import React from 'react';

const CollectionHistory = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Collection History</h1>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="text-center py-8 text-gray-500">
          <p>Collection history feature is under development.</p>
          <p className="text-sm mt-2">Check back soon for complete collection history.</p>
        </div>
      </div>
    </div>
  );
};

export default CollectionHistory;